import { useState } from 'react';
import { useLang } from '@/hooks/useLang';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryHub from './components/CategoryHub';
import ContentSections from './components/ContentSections';
import TrustSections from './components/TrustSections';
import FaqSection from './components/FaqSection';
import { homeContent } from '@/data/home';
import { useSeo, SITE_URL, SITE_NAME, SITE_LOGO_URL } from '@/lib/seo';
import { useJsonLd } from '@/lib/jsonld';

export default function Home() {
  const lang = useLang();
  const [search, setSearch] = useState('');

  useSeo({
    title: 'AllChinaBuy Spreadsheet: Complete Guide, Products & Sellers',
    description: 'Discover the AllChinaBuy Spreadsheet — organized resources for products, sellers, shipping costs, QC tips, coupons and shopping guides. Independent, beginner-friendly information hub.',
    keywords: 'AllChinaBuy spreadsheet, AllChinaBuy review, AllChinaBuy shipping cost, AllChinaBuy coupon, AllChinaBuy warehouse',
    canonicalPath: '/',
    ogType: 'website',
    ogTitle: 'AllChinaBuy Spreadsheet: Complete Guide, Products & Sellers',
    ogDescription: 'Organized resources for AllChinaBuy products, sellers, shipping, QC, coupons and shopping guides. An independent, beginner-friendly information hub.',
    ogSiteName: SITE_NAME,
    twitterTitle: 'AllChinaBuy Spreadsheet: Complete Guide, Products & Sellers',
    twitterDescription: 'Organized resources for AllChinaBuy products, sellers, shipping, QC, coupons and shopping guides.',
  });

  useJsonLd('home-jsonld', [
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: SITE_NAME,
      url: SITE_URL,
      inLanguage: 'en',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL,
      logo: { '@type': 'ImageObject', url: SITE_LOGO_URL },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: homeContent[lang].faq.items.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    },
  ]);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero lang={lang} search={search} onSearch={setSearch} />
        <CategoryHub lang={lang} search={search} />
        <ContentSections lang={lang} />
        <TrustSections lang={lang} />
        <FaqSection lang={lang} />
      </main>
      <Footer />
    </div>
  );
}